function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.0995 8.78809H4.64835C4.13494 8.78809 3.71875 9.22223 3.71875 9.75778V27.2123C3.71875 27.7479 4.13494 28.182 4.64835 28.182H25.0995C25.6129 28.182 26.0291 27.7479 26.0291 27.2123V9.75778C26.0291 9.22223 25.6129 8.78809 25.0995 8.78809Z",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.71875 23.3335L9.56859 17.2313C9.65491 17.1412 9.75738 17.0698 9.87017 17.0211C9.98295 16.9723 10.1038 16.9473 10.2259 16.9473C10.348 16.9473 10.4689 16.9723 10.5817 17.0211C10.6944 17.0698 10.7969 17.1412 10.8832 17.2313L16.0758 22.6478C16.1621 22.7379 16.2646 22.8093 16.3773 22.858C16.4901 22.9067 16.611 22.9318 16.7331 22.9318C16.8552 22.9318 16.976 22.9067 17.0888 22.858C17.2016 22.8093 17.3041 22.7379 17.3904 22.6478L19.7941 20.1404C19.8805 20.0503 19.9829 19.9789 20.0957 19.9302C20.2085 19.8814 20.3294 19.8564 20.4515 19.8564C20.5735 19.8564 20.6944 19.8814 20.8072 19.9302C20.92 19.9789 21.0225 20.0503 21.1088 20.1404L26.029 25.2729",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.1268 16.5453C18.8969 16.5453 19.5212 15.8941 19.5212 15.0908C19.5212 14.2875 18.8969 13.6362 18.1268 13.6362C17.3567 13.6362 16.7324 14.2875 16.7324 15.0908C16.7324 15.8941 17.3567 16.5453 18.1268 16.5453Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M24.5257 14.0471V15.0471H25.5257H26.9255H27.9255V14.0471V9.75365H32H33V8.75365V7.2934V6.2934H32H27.9255V2V1H26.9255H25.5257H24.5257V2V6.2934H20.4512H19.4512V7.2934V8.75365V9.75365H20.4512H24.5257V14.0471Z",
  fill: "black",
  stroke: "white",
  strokeWidth: 2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M25.5257 14.0471H26.9255V8.75365H32V7.2934H26.9255V2H25.5257V7.2934H20.4512V8.75365H25.5257V14.0471Z",
  fill: "black"
});

function SvgAddImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImage);
export default __webpack_public_path__ + "static/media/AddImage.397ee2a0b9e0df887ba9a29d87e9d779.svg";
export { ForwardRef as ReactComponent };